import { IonIcon, IonText } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { arrowRightIcon } from "@/lib/icons/@heroicons/react/20/solid";
import { useMyProgression } from "@/lib/query/functions/user/progression";
import { Routes } from "@/lib/router";
import { DynamicAvatar } from "../CoreValue/DynamicAvatar";
import { Button } from "../Global/Button";

export function CoreValuesWidget() {
	const { t } = useTranslation();
	const [myProgression] = useMyProgression();

	return (
		<div className="bg-brown-100 flex flex-col items-center gap-2 rounded-3xl px-4 pt-9 pb-2">
			<DynamicAvatar accuracyType="small" />

			<Button
				variant="clear"
				size="text"
				className="flex items-center"
				routerLink={
					myProgression.chosen_core_values === "NOT_STARTED"
						? Routes.CoreValuesOverview()
						: Routes.CoreValuesDashboard()
				}
				routerDirection="forward"
			>
				<IonText>{t("widgets.core-values.action")}</IonText>
				<IonIcon icon={arrowRightIcon} className="text-brown-400 size-4" />
			</Button>
		</div>
	);
}
